import {useTranslation} from "react-i18next";

const Currency = (props) => {
    const {value} = props;
    const {i18n} = useTranslation();
    const locale = `${i18n.language}-CA`;
    var formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol'
    });

    return formatter.format(value);
};

export default Currency;
